<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-declaracion-jurada />
    <h3 class="primary--text">
      <v-icon color="primary">offline_pin</v-icon> Declaración jurada
    </h3>
    <ver-documento />
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
              v-if="estado==1"
                color="primary"
                dark
                @click.native.stop="crearActualizarDeclaracionJurada({})"
                slot="activator"
                ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
              >
              <span>Agregar Declaracion jurada</span>
            </v-tooltip>
          </template>

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->

            <td class="text-xs-center">
              {{
                items.item.parametro_motivo
                  ? items.item.parametro_motivo.valor
                  : ""
              }}
            </td>
            <td class="text-xs-center">{{ items.item.codigo_control }}</td>
            <!-- <td class="text-xs-center">{{ items.item.numero_certificado? items.item.numero_certificado : "No"  }}</td> -->

            <td class="text-xs-center">
              {{ $moment(items.item.fecha_cge).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_mefp).format("DD/MM/YYYY") }}
            </td>

            <td class="text-xs-center">{{ items.item.observacion }}</td>
            <!-- <td title="Activar/Desactivar declaracionJurada">
              <v-switch
                value
                :input-value="items.item.id_estado === '1' ? true : false"
                @change="cambiarEstado(items.item)"
              ></v-switch>
            </td> -->
            <td class="nowrap">
              <v-tooltip bottom v-if="estado==1">
                <v-btn
                  icon
                  color="primary"
                  slot="activator"
                  @click.native="crearActualizarDeclaracionJurada(items.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  color="green"
                  dark
                  icon
                  slot="activator"
                  @click.native="verDocumento(items.item)"
                >
                  <v-icon color="dark">visibility</v-icon>
                </v-btn>
                <span>Ver registro</span>
              </v-tooltip>
              <v-tooltip bottom v-if="estado==1">
                <v-btn
                  color="red"
                  dark
                  icon
                  slot="activator"
                  @click="deleteItem(items.item.id, 'declaracionJurada')"
                >
                  <v-icon color="dark">delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarDeclaracionJurada from "../dialogs/CrearActualizarDeclaracionJurada"; // Componente de creación y actualización
import VerDocumento from "../dialogs/VerDocumento.vue";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  props: ["persona"],

  // Variables iniciales del componente
  data() {
    return {
      url: "declaracionJuradas",
      graphql: true,
      // Cabecera de la tabla
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        { text: "Motivo", value: "id_parametro_motivo", align: "center" },
        { text: "Código de Control", value: "codigo_control", align: "center" },
        // {
        //   text: "Nro de Certificado",
        //   value: "numero_certificado",
        //   align: "center"
        // },
        {
          text: "Fecha de Presentación DJBR-CGE",
          value: "fecha_cge",
          align: "center"
        },
        {
          text: "Fecha de Presentación DJBR/ASP-B",
          value: "fecha_mefp",
          align: "center"
        },
        { text: "Observación", value: "observacion", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
        id
        codigo_control
        numero_certificado
        fecha_cge
        fecha_mefp
        observacion
        url_documento
        id_parametro_motivo
        id_estado
        id_persona
        parametro_motivo{
          id 
          valor
        }
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      filters: [],
      initData: [
        {
          state: true,
          param: "id_persona",
          value: this.persona.id
        }
      ],
      estado:[],
      rol:[]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    this.$bus.$on("verDocumento", item => {
      this.url = item;
      this.dialog = true;
    });
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.obtenerEstadoFicha();
  },
  // Métodos y funciones del componente
  methods: {
    async verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    },
    crearActualizarDeclaracionJurada(item) {
      this.$bus.$emit("openDialogCrearActualizarDeclaracionJurada", item);
    },
    async cambiarEstado(item) {
      let value = item.id_estado === "20" ? 1 : 20;
      let data = {
        id_estado: value
      };
      try {
        await this.$service.graphql({
          query: `
            mutation edit($id: ID!, $declaracion_jurada: EditDeclaracionJurada!) {
              declaracionJuradaEdit(id: $id, declaracion_jurada: $declaracion_jurada) {
                id
              }
            }
          `,
          variables: {
            id: item.id,
            declaracion_jurada: data
          }
        });
        if (value === 1) {
          this.$message.success("Declaracion Jurada habilitado");
        } else {
          this.$message.warning("Declaracion Jurada deshabilitado");
        }
        this.updateList();
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
      this.rol=user.roles[0].id;
      let respuesta = await this.$service.graphql({
        query: `
          query{
                  vListafichas(id_persona:${user.id_persona}){
                    rows{
                      id_persona
                      nombre
                      nro_doc
                      id_estado_ficha
                      estado_ficha
                      habilitado
                      item
                      id_unidad
                      unidad      
                    }
                  }
                }
        `
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado=this.estados_ficha[0].habilitado
      let roles = user.roles;
      roles.forEach(element => {
      if(element.id==115){
        this.estado=1
      }
    });
    },
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarDeclaracionJurada,
    VerDocumento
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/DeclaracionJurada.vue